import { createQueryKeys } from "@lukemorales/query-key-factory";
import { tags, type MaybeRef, type DeepMaybeRef } from "../common";
import type { ListMovementsRequest } from ".";

export const movementKeys = createQueryKeys(tags.zoolander.movements, {
  list: (filters: DeepMaybeRef<ListMovementsRequest>) => [{ filters }],
  count: (filters: DeepMaybeRef<ListMovementsRequest>) => [{ filters }],
  byId: (movementId: MaybeRef<string>) => [movementId],
});

export const movementFieldKeys = createQueryKeys(
  tags.zoolander.movementFields,
  {
    byMovementId: (movementId: MaybeRef<string>) => [movementId],
  }
);
